import { render, staticRenderFns } from "./OverviewIcon.vue?vue&type=template&id=98acf08c"
import script from "./OverviewIcon.vue?vue&type=script&lang=js"
export * from "./OverviewIcon.vue?vue&type=script&lang=js"
import style0 from "./OverviewIcon.vue?vue&type=style&index=0&id=98acf08c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports